exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".image-qr {\n  width: 70%;\n  height: 70%;\n  max-width: 400px;\n  max-height: 400px;\n  position: initial; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/rider/components/rider-qr-code/view-qr-code/view-qr-code.component.scss
// module id = 2093
// module chunks = 66